<template>
  <div class="my-12 text-center">
    <h1 class="pt-0 font-5xl tracking-wide leading-loose font-semibold text-center uppercase">
      WE'RE HERE TO HELP
    </h1>
    <p class="leading-normal pb-8 text-lg">
      Our friendly team are here for you
    </p>
    <div class="flex-wrap flex flex-row sm:flex-no-wrap justify-center content-container">
      <div class="w-full text-center lg:bg-grey py-10 lg:px-10 lg:mr-6 md:mr-6">
        <p class="font-bold text-2xl uppercase pt-5 pb-2">
          CALL US NOW
        </p>
        <p class="leading-normal h-32 md:h-36">
          Our support team are available 7 days a week Monday to Friday - 8:00am to 9:00pm AEDT and Saturday & Sunday - 9:00am to 9:00pm AEDT.
        </p>
        <a
          class="border-2 rounded-full border-green-dark lg:text-lg bg-white uppercase no-underline text-black lg:px-8 px-2 py-2 cursor-pointer"
          :href="`tel:${brand.phone}`"
          @click="pushGtmEvent('phone')"
        >
          call {{ brand.phone }}
        </a>
      </div>

      <div class="w-full text-center lg:bg-grey py-10 lg:px-10 lg:mr-6 md:mr-6">
        <p class="font-bold text-2xl uppercase pt-5 pb-2">
          Email us
        </p>
        <p class="leading-normal h-32 md:h-36">
          Submit your request via our Contact Form or alternatively, email us directly at {{ brand.support }}
        </p>
        <a
          class="border-2 rounded-full border-green-dark lg:text-lg md:h-12 bg-white uppercase no-underline text-black lg:px-8 px-2 py-2 cursor-pointer"
          :href="`mailto:${brand.support}`"
          @click="pushGtmEvent('email')"
        >
          Customer Support
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import MovingHelpbngy from '~/components/Icons/MovingHelpbngy.vue'
// import EmailHelpbngy from '~/components/Icons/EmailHelpbngy.vue'

export default {
  components: {
    // MovingHelpbngy,
    // EmailHelpbngy
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  },
  methods: {
    pushGtmEvent(type) {
      switch (type) {
        case 'phone':
          this.$gtm.pushEvent({ event: 'CALLS' })
          break
        case 'email':
          this.$gtm.pushEvent({ event: 'EMAIL' })
          break
        case 'relocation':
          this.$gtm.pushEvent({ event: 'RELOCATION_CALLS' })
          break
        default:
          break
      }
    }
  }
}
</script>
